









































































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import { IUser } from '../../store/profile/types';
import validator from 'validator';
import AuthQuery from '~/mixins/AuthQuery';
import TwoFactorAuthInputPrompt from '~/components/ModalPrompts/TwoFactorAuthInputPrompt.vue';
import { twoFaErrorCodes } from '~/utils/errorCodes';
import { TwoFaCheckpoint } from '~/types/two-fa-checkpoints';

@Component({ components: { TwoFactorAuthInputPrompt } })
export default class UpdatePhone extends Mixins(AuthQuery) {
  @State(profile => profile.user, { namespace: 'profile' })
  // @ts-ignore -- "user" is used in template section.
  private user!: IUser;
  @Prop(Function) readonly closeDialog!: () => void;

  @Action('updateUser', { namespace: 'profile' })
  private updateUser!: (args: any) => void;

  editing = false;
  newPhoneNumber = '';
  phoneRules = [this.validatePhone];
  phonePlaceholder = '';

  async handleSave() {
    await this.doAuthQuery(async totpToken => {
      const strippedNumber = this.newPhoneNumber.replace(/[-()\s]/g, '');

      await this.updateUser({
        phone: strippedNumber,
        totpToken,
        rethrowErrorCodes: twoFaErrorCodes,
      });

      this.editing = false;
      this.newPhoneNumber = '';
      this.closeDialog();
    }, TwoFaCheckpoint.accountModifications);
  }

  validatePhone(input?: string) {
    if (!input)
      return this.$t('components.settings.updatePhone.enterValidNumberMsg');
    return (
      validator.isMobilePhone(input, 'any') ||
      this.$t('components.settings.updatePhone.enterValidNumberMsg')
    );
  }

  cancelEdit() {
    this.editing = !this.editing;
    this.newPhoneNumber = '';
  }
}
